import { c as _c } from "react/compiler-runtime";
import { Box, Text } from "@chakra-ui/react";
interface PillProps {
  exists: boolean | undefined;
  trueData: string;
  falseData: string;
  noData: string;
}
const Pill: React.FC<PillProps> = t0 => {
  const $ = _c(10);
  const {
    exists,
    trueData,
    falseData,
    noData
  } = t0;
  let t1;
  if ($[0] !== exists) {
    t1 = () => {
      switch (exists) {
        case true:
          {
            return "red";
          }
        case false:
          {
            return "green";
          }
        default:
          {
            return "lightGrey";
          }
      }
    };
    $[0] = exists;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const getColor = t1;
  const color = getColor();
  let t2;
  if ($[2] !== exists || $[3] !== falseData || $[4] !== noData || $[5] !== trueData) {
    const getLabel = () => {
      switch (exists) {
        case true:
          {
            return trueData;
          }
        case false:
          {
            return falseData;
          }
        default:
          {
            return noData;
          }
      }
    };
    t2 = getLabel();
    $[2] = exists;
    $[3] = falseData;
    $[4] = noData;
    $[5] = trueData;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const label = t2;
  let t3;
  if ($[7] !== color || $[8] !== label) {
    t3 = <Box><Text bgColor={color} color="white" py="0.5" px="3" borderRadius="full" whiteSpace="nowrap">{label}</Text></Box>;
    $[7] = color;
    $[8] = label;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
};
export default Pill;